/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { equalScalarDependencies } from './dependenciesEqualScalar.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { roundDependencies } from './dependenciesRound.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createFloor } from '../../factoriesAny.js';
export var floorDependencies = {
  equalScalarDependencies,
  matrixDependencies,
  roundDependencies,
  typedDependencies,
  createFloor
};